import script from "./monthylColumChart.vue?vue&type=script&setup=true&lang=js"
export * from "./monthylColumChart.vue?vue&type=script&setup=true&lang=js"

import "./monthylColumChart.vue?vue&type=style&index=0&id=2fd13af8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fd13af8"]])

export default __exports__